/*
  Dialog
*/
import { enter, leave } from 'el-transition'
import * as Turbo from '@hotwired/turbo'
import { i18n } from '/libs/i18n'

export default class Dialog {
  constructor(message, options = {}) {
    this.message = message
    this.title = options.title
    this.okText = options.ok || i18n.t('common.actions.ok')
  }

  show() {
    this.buildNode()

    document.body.appendChild(this.element)
    enter(this.background)
    enter(this.panel)

    return new Promise((resolve, reject) => {
      this.element.querySelectorAll('[data-dialog-resolve]').forEach((button) => {
        button.addEventListener('click', (e) => {
          this.remove()
          resolve(e.target.dataset.dialogResolve === 'true')
        }, { once: true })
      })
    })
  }

  remove() {
    leave(this.background)
    leave(this.panel).then(() => {
      this.element.remove()
    })
  }

  buildNode() {
    const placeholder = document.createElement('div')
    placeholder.innerHTML = this.template()

    this.element = placeholder.firstElementChild
    this.background = this.element.firstElementChild
    this.panel = this.element.querySelector('[data-dialog-panel]')
  }

  template() {
    return `
      <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div data-transition-enter="ease-out duration-300" data-transition-enter-start="opacity-0" data-transition-enter-end="opacity-100" data-transition-leave="ease-in duration-200" data-transition-leave-start="opacity-100" data-transition-leave-end="opacity-0" class="fixed inset-0 bg-gray-500/75 transition-opacity"></div>

        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div data-dialog-panel data-transition-enter="ease-out duration-300" data-transition-enter-start="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" data-transition-enter-end="opacity-100 translate-y-0 sm:scale-100" data-transition-leave="ease-in duration-200" data-transition-leave-start="opacity-100 translate-y-0 sm:scale-100" data-transition-leave-end="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              ${this.templateContent()}
            </div>
          </div>
        </div>
      </div>
    `
  }

  templateContent() {
    return `
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4">
            ${this.#templateTitle()}
            <div class="mt-2">
              <p class="text-sm text-gray-500">${this.message}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="px-4 py-3 sm:px-6 flex items-center justify-center">
        <button type="button" data-dialog-resolve="true" class="min-w-28 inline-flex justify-center rounded-md bg-primary-600 hover:bg-primary-700 focus-visible:outline-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2">${this.okText}</button>
      </div>
    `
  }

  #templateTitle() {
    if (!this.title) return ''
    return `<h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">${this.title}</h3>`
  }
}
